<template>
    <div>
        <span class="close-btn el-icon-close" @click="closeModal"></span>
        <div class="content-box mr60">
            <p style="text-align: center;margin-top: -15px;">以下项目有未使用的素材，建议优先使用。</p>
            <div style="max-height: 250px;overflow-y: auto;">
                <div v-for="(item,index) in list" :key="item.project_id+index">
                    <p class="text-bold">{{index+1}}、{{item.project_name}}(ID：{{item.project_id||'-'}})</p>
                    <div class="sub-text ml20 font12px">
                        <p v-for="(value,key) in item.list" :key="value+key">素材尺寸：{{key}}，未使用素材数量：{{value}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="goOnSubmit" :disabled="countdown>0" class="action-btn mr20">继续提交 <span v-if="countdown>0">({{countdown}}s)</span></el-button>
            <el-button type="primary" @click="toProjectPage" class="action-btn ml20">去查看</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "SubmitTipModal",
        props:{
            cbs:{
                type:Object,
            },
            list:Array,
        },
        data(){
            return {
                countdown:3,
            }
        },
        mounted(){
            setTimeout(()=>{
                this.startTimer();
            },1000)
        },
        methods:{
            startTimer(){
                this.countdown--;
                if(this.countdown>0){
                    setTimeout(()=>{
                        this.startTimer();
                    },1000)
                }
            },
            goOnSubmit(){
                console.log('goOnSubmit');
                if(this.countdown>0) return;
                this.cbs.goOnSubmit({});
                this.$emit('close');

            },
            toProjectPage(){
                this.cbs.toProjectPage({});
                console.log('toProjectPage');
                this.$emit('close');
            },
            closeModal(){
                console.log('closeModal');
                this.cbs.onClose({});
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .close-btn{
        display: block;
        position: absolute;
        right: 20px;
        top: 16px;
        cursor: pointer;
        font-size: 16px;
        &:hover{
            color: #00b3ee;
        }
    }
</style>
